import Counter from "./components/Counter";
import Board from "./components/Board";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import MedicineList from "./views/medicines/MedicineList";
import { Login } from "./views/Login";
import SymptomList from "./views/symptoms/SymptomList";
import UserList from "./views/users/UserList";
import Dashboard from "./views/dashboard/Dashboard";
import CompanyList from "./views/companies/CompanyList";
import DisorderList from "./views/disorder/DisorderList";
import ExpenseCategoryList from "./views/expense-categories/ExpenseCategoryList";
import ExpenseList from "./views/expenses/ExpenseList";
import Logs from "./views/logs/Logs";
import RolesAndPermissionsList from "./views/roles-and-permissions/RolesAndPermissionsList";
import AddPatient from "./views/patients/AddPatient";
import PatientList from "./views/patients/PatientList";
import LayoutDesign from "./views/layoutDesign/LayoutDesign";
import AddUser from "./views/users/AddUser";
import ServiceList from "./views/services/ServiceList";
import VisitList from "./views/visits/VisitList";
import VisitTimeline from "./views/visits/VisitTimeline";
import IPDTimeline from "./views/visits/ipd/IPDTimeline";
import EpisodeList from "./views/episodes/EpisodeList";
import VisitRegisterList from "./views/visit-register/VisitRegisterList";
import Calendar from "./views/calender/Calender";
import LanguageProvider from "./providers/LanguageProvider";
import VisitTypes from "./views/visits/VisitTypes";
import PageNotFound from "./views/404";
import { loginLoader, userLoader } from "./utils/RouteLoader";
import SettingsList from "./views/settings/SettingsList";
import VisitTransactionList from "./views/visits/VisitTransactionList";
// import ResetPassword from "./views/ResetPassword";
import ResetPassword from "./views/ResetPassword";
import ViewCompletedVisits from "./views/visits/ViewCompletedVisits";
import Profile from "./views/Profile";
// import PatientAppointment from "./views/PatientAppointment";
// import BookedAppointment from "./views/BookedAppointment";
import VisitTypeList from "./views/visit-types/VisitTypeList";
import EpisodeTypeList from "./views/episode-types/EpisodeTypeList";
import ReferralsList from "./views/referral/ReferralsLists";
import LabOrderList from "./views/laboratory/LabOrderList";
import PharmacyItemsList from "./views/Pharmacy Items/PharmacyItemsList";
import SupplierList from "./views/Suppliers/SupplierList";
import PurchaseOrdersList from "./views/purchase-orders/PurchaseOrdersList";
import AddPurchaseOrder from "./views/purchase-orders/AddPurchaseOrder";
import GRNs from "./views/GRNs/GRNs";
import AddGRNForm from "./views/GRNs/AddGRNsForm";
import RoomTypes from "./views/Bed Management/RoomTypes";
import Rooms from "./views/Bed Management/Rooms";
import BedLayout from "./views/Bed Management/BedLayout";
import BedLayout3D from "./views/Bed Management/BedLayout3D";
import TestList from "./views/laboratory/Tests";
import GrnItemsDetail from "./views/GRNs/GrnItemsDetail";
import Categories from "./views/laboratory/Categories";
import AddTest from "./views/laboratory/AddTest";
import EditLabOrder from "./views/laboratory/EditLabOrder";
import ViewLabOrder from "./views/laboratory/ViewLabOrder";
import ViewLabTest from "./views/laboratory/ViewLabTest";
import PatientTransactionList from "./views/patient-transactions/PatientTransactionList";
import PharmacyPOS from "./views/pharmacy/POS";
import POSList from "./views/pharmacy/POSList";
import ViewPurchaseOrder from "./views/purchase-orders/ViewPurchaseOrder";
import DepartmentsList from "./views/Departments/DepartmentsList";
import IPDVisits from "./views/IPD OPD Visits/IPDVisitsList"
import OPDVisits from "./views/IPD OPD Visits/OPDVisitsList";
import PackagesList from "./views/Packages/PackagesList";
import MastersDashboard from "./views/masters/MastersDashboard";
import DutyRoster from "./views/duty-roster/DutyRoster";
import ShiftAssignmentsList from "./views/duty-roster/ShiftAssignmentsList";
import BillingList from "./views/billing/BillingList";
import DoctorPayouts from "./views/doctor-payouts/DoctorPayouts";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <Login />,
      errorElement: <PageNotFound />,
      loader: loginLoader,
    },

    {
      path: "/auth/reset-password",
      errorElement: <PageNotFound />,

      element: <ResetPassword />,
    },
    //this following route is for patient to create an appointment
    // {
    //   path: "/appointment",
    //   errorElement: <PageNotFound />,
    //   element: <PatientAppointment />,
    // },
    // {
    //   path: "/booked-appointment/:visitId",
    //   errorElement: <PageNotFound />,
    //   element: <BookedAppointment />,
    // },
    {
      path: "/",
      element: <Layout />,
      errorElement: <PageNotFound />,
      loader: userLoader,
      children: [
        {
          path: "/layout-design",
          element: <LayoutDesign />,
        },
        {
          path: "/patients/new",
          element: <AddPatient />,
        },
        {
          path: "/patients/:patientId",
          element: <AddPatient />,
        },
        {
          path: "/patients",
          element: <PatientList />,
        },
        {
          path: "/medicines",
          element: <MedicineList />,
        },
        {
          path: "/departments",
          element: <DepartmentsList />,
        },
        {
          path: "/packages",
          element: <PackagesList />,
        },
        {
          path: "/companies",
          element: <CompanyList />,
        },
        {
          path: "/users",
          element: <UserList />,
        },
        {
          path: "/users/new",
          element: <AddUser />,
        },
        {
          path: "/users/:userId",
          element: <AddUser />,
        },
        {
          path: "/symptoms",
          element: <SymptomList />,
        },
        {
          path: "/dashboard",
          element: <Dashboard />,
        },
        {
          path: "/disorders",
          element: <DisorderList />,
        },
        {
          path: "/expense-categories",
          element: <ExpenseCategoryList />,
        },
        {
          path: "/expenses",
          element: <ExpenseList />,
        },
        {
          path: "/services",
          element: <ServiceList />,
        },
        {
          path: "/logs",
          element: <Logs />,
        },
        {
          path: "/roles-and-permissions",
          element: <RolesAndPermissionsList />,
        },
        {
          path: "/visits",
          element: <VisitList />,
        },
        {
          path: "/episodes",
          element: <EpisodeList />,
        },
        {
          path: "/patients/:patientId/visits/types",
          element: <VisitTypes />,
        },
        {
          path: "/ipd-visits",
          element: <IPDVisits />,
        },
        {
          path: "/opd-visits",
          element: <OPDVisits />,
        },
        // OPD visit timeline
        { 
          path: "/visits/:visitId",
          element: <VisitTimeline />,
        },
        {
          path: "/opd/visits/:visitId",
          element: <VisitTimeline />,
        },
        {
          path: "/opd/clinic-visit-types/:clinicVisitTypeId/patients/:patientId",
          element: <VisitTimeline />,
        },
        // IPD visit timeline
        {
          path: "/ipd/visits/:visitId",
          element: <IPDTimeline />,
        },
        {
          path: "/ipd/clinic-visit-types/:clinicVisitTypeId/patients/:patientId",
          element: <IPDTimeline />,
        },
        {
          path: "/view/visits/:visitId",
          element: <ViewCompletedVisits />,
        },
        
        {
          path: "/visit-register",
          element: <VisitRegisterList />,
        },
        {
          path: "/calendar",
          element: <Calendar />,
        },
        {
          path: "/settings",
          element: <SettingsList />,
        },
        {
          path: "/billing",
          element: <BillingList />,
        },
        {
          path: "/doctor-payouts",
          element: <DoctorPayouts />,
        },
        {
          path: "/masters",
          element: <MastersDashboard />,
        },
        {
          path: "/duty-roster",
          element: <DutyRoster />,
        },
        {
          path: "/shift-assignments",
          element: <ShiftAssignmentsList />,
        },
        {
          path: "/transactions/visits/:visitId",
          element: <VisitTransactionList />,
        },
        // {
        //   path: "/prescription/visits/:visitId",
        //   element: <Prescription />,
        // },
        {
          path: "/profile/:userId",
          element: <Profile />,
        },
        {
          path: "/visit-types-list",
          element: <VisitTypeList />,
        },
        {
          path: "/episode-types",
          element: <EpisodeTypeList />,
        },
        {
          path: "/referrals",
          element: <ReferralsList />,
        },
        // {
        //   path: "/laboratory",
        //   element: <LabOrderList />,
        // },
        {
          path: "/lab-order-list",
          element: <LabOrderList />,
        },
        {
          path: "/lab-orders/edit/:id",
          element: <EditLabOrder />,
        },
        {
          path: "/lab-orders/view/:id",
          element: <ViewLabOrder />,
        },
        {
          path: "/test-list",
          element: <TestList />,
        },
        {
          path: "/lab-tests/add",
          element: <AddTest />,
        },
        {
          path: "/lab-tests/edit/:id",
          element: <AddTest />,
        },
        {
          path: "/lab-tests/view/:id",
          element: <ViewLabTest />,
        },
        {
          path: "/lab-categories",
          element: <Categories />,
        },
        {
          path: "items-list",
          element: <PharmacyItemsList />,
        },
        {
          path: "supplier-list",
          element: <SupplierList />,
        },
        {
          path: "purchase-orders",
          element: <PurchaseOrdersList />,
        },
        {
          path: "/purchase-orders/view/:id",
          element: <ViewPurchaseOrder />,
        },
        {
          path: "purchase-orders/add",
          element: <AddPurchaseOrder />,
        },
        {
          path: "/purchase-orders/edit/:id",
          element: <AddPurchaseOrder />,
        },
        {
          path: "GRNs",
          element: <GRNs />,
        },
        {
          path: "/add-grn",
          element: <AddGRNForm />,
        },
        {
          path: "/grns/edit/:id",
          element: <AddGRNForm />,
        },
        {
          path: "/grn/:id",
          element: <GrnItemsDetail />,
        },
        {
          path: "/room-types",
          element: <RoomTypes />,
        },
        {
          path: "/rooms",
          element: <Rooms />,
        },
        {
          path: "/bed-layout",
          element: <BedLayout />,
        },
        {
          path: "/bed-layout-3d",
          element: <BedLayout3D />,
        },
        {
          path: "/patient-transactions",
          element: <PatientTransactionList />,
        },
        {
          path: "/patients/:patientId/transactions",
          element: <PatientTransactionList />,
        },
        {
          path: "/pharmacy/pos",
          element: <PharmacyPOS />,
        },
        {
          path: "/pharmacy/pos/list",
          element: <POSList />,
        },
      ],
    },
    {
      path: "/board",
      element: <Board />,
    },

    {
      path: "/counter",
      element: <Counter />,
    },
  ]);
  return (
    <LanguageProvider>
      <RouterProvider router={router}></RouterProvider>
    </LanguageProvider>
  );
};

export default App;
